<template>
<div>
  <div class="hotel-category">
    {{hotelGroup.category}}
    <span class="price-estimate">
      <font-awesome-icon icon="dollar-sign" v-for="n in hotelGroup.dollarSigns" v-bind:key="n" />
    </span>
  </div>
  <div class="hotel-category-body">
    <ul class="hotel-details-tags">
      <a :href="'#' + hotel.id"
        v-for="hotel in hotelGroup.hotels">
        <li class="tag is-rounded is-link">
          {{hotel.name}}
        </li>
      </a>
    </ul>
    <div :id="hotel.id"
      class="notification hotel-details"
      v-for="hotel in hotelGroup.hotels">
      <div class="title">
        {{hotel.name}}
        <span v-if="hotel.estimatedPrice"
          class="estimated-price">~${{hotel.estimatedPrice}}</span>
      </div>
      <span class="hotel-description">{{hotel.description}}</span>
      <img v-bind:class="{'hotel-image': hotel.description}"
        :src="hotel.imageUrl"
        :alt="hotel.altText"
        v-if="hotel.imageUrl" />
      <div class="address"
        v-if="hotel.address">
        <div class="line-one">{{hotel.address.lineOne}}</div>
        <div class="line-two">{{hotel.address.lineTwo}}</div>
      </div>
      <div class="directions">
        <span v-if="hotel.website"><a :href="hotel.website" target="_blank">Website</a> | </span><a v-if="hotel.directions"
          :href="hotel.directions"
          target="_blank">Directions</a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
const HOTEL_CAROUSEL_INTERVAL_IN_MS = 5000;
var HOTEL_CAROUSEL_INTERVAL;

export default {
  name: 'HotelCarousel',
  props: ['hotelGroup'],
  data: function () {
    return {
      hasTouched: false,
    }
  },
}
</script>

<style>
.tag.selected {
  font-weight: bold;
}

.hotel-details-tags,
.hotel-details {
  font-size: 0.8em;
}

.hotel-details .title {
  font-size: 1.1em;
  font-weight: bold;
}

.hotel-category-body {
  border: solid 1px #7957d5;
  border-radius: 1em;
}

.hotel-details,
.hotel-details-tags {
  border-radius: 2em !important;
}

.estimated-price {
  margin-left: 1em;
  font-size: 0.8em;
}

.tag.selected,
.hotel-details,
.hotel-details-tags {
  color: black !important;
  background-color: white !important;
}

.hotel-details {
  margin-bottom: 0 !important;
}

.hotel-description {
  margin-bottom: 4px;
}

.hotel-image {
  margin-top: 8px;
}

.hotel-details-tags {
  padding: 8px;
  overflow: scroll;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
